export default __webpack_public_path__ + "static/media/spid-agid-logo-lb.6111769a.png";